/**
 * This module handles selecting a season from the season-selector dropdown.
 */
var $ = require('jQuery');

$('.content').on("select2-selecting", "#seasonSelector", function(e) {
    // Switch Selected Season
    $.pjax({url: "/season/filterby/" + e.val, container: '#pjaxContainer', method: 'GET'});
});
